const categories = [
    {
        name: "Продукти",
        subcategories: [
            "Плодове и зеленчуци",
            "Хлебни изделия",
            "Био и веган продукти",
            "Пресни храни",
            "Домашни любимци",
            "Продукти"
        ]
    },
    {
        name: "Млечни продукти и яйца",
        subcategories: [
            "Кашкавал",
            "Кисело мляко",
            "Масло, маргарин и майонеза",
            "Прясно мляко",
            "Сирене",
            "Сметана",
            "Яйца",
            "Веган продукти",
            "Млечни продукти и яйца"
        ]
    },
    {
        name: "Месни продукти",
        subcategories: [
            "Кайма",
            "Малотрайни колбаси",
            "Трайни колбаси",
            "Прясно месо",
            "Месни продукти"
        ]
    },
    {
        name: "Замразени продукти и сладолед",
        subcategories: [
            "Замразени зеленчуци",
            "Замразени месни",
            "Замразени тестени",
            "Сладоледи",
            "Замразени продукти и сладолед"
        ]
    },
    {
        name: "Захарни изделия, ядки и чипс",
        subcategories: [
            "Барове и десерти",
            "Бисквити",
            "Бонбони",
            "Вафли",
            "Дъвки",
            "Кроасани",
            "Солени",
            "Чипс",
            "Течен шоколад",
            "Шоколади",
            "Ядки, сушени плодове и супер храни",
            "Захарни изделия, ядки и чипс"
        ],
    },
    {
        name: "Алкохол",
        subcategories: [
            "Бира",
            "Вино",
            "Високоалкохолни",
            "Алкохол"
        ],
    },
    {
        name: "Безалкохолни",
        subcategories: [
            "Газирани напитки",
            "Енергийни напитки",
            "Минерална вода",
            "Негазирани напитки",
            "Безакохолни"
        ],
    },
    {
        name: "Козметика",
        subcategories: [
            "За коса",
            "За лице",
            "За тяло",
            "За уста",
            "За други",
            "Козметика"
        ],
    },
    {
        name: "За дома",
        subcategories: [
            "Домашни потреби",
            "Перилни препарати",
            "Почистващи препарати",
            "Препарати за съдове",
            "Санитарни",
            "Лични предпазни средства",
            "За дома",
        ],
    },
    {
        name: "Пакетирани храни и консерви",
        subcategories: [
            "Брашно",
            "Варива",
            "Захар и сол",
            "Зехтин, олио и оцет",
            "Консерви",
            "Макаронени изделия",
            "Мюсли и овесени ядки",
            "Подправки",
            "Сосове",
            "Фиксове и полуфабрикати",
            "Топли напитки",
            "Пакетирани храни и консерви"
        ],
    },
    {
        name: "Тютюневи изделия",
        subcategories: [
            "Цигари",
            "Пури",
            "Тютюневи изделия"
        ]
    },
    {
        "name": "Авто, мото, вело",
        "subcategories": [
            "Автомобили",
            "Мотоциклети",
            "Велосипеди",
            "Части и аксесоари",
            "Гуми и джанти",
            "Авто, мото, вело"
        ]
    },
    {
        "name": "Видеонаблюдение",
        "subcategories": [
            "Камери",
            "DVR/NVR системи",
            "Аксесоари",
            "Софтуер",
            "Мониторинг услуги",
            "Видеонаблюдение"
        ]
    },
    {
        "name": "Дом и градина",
        "subcategories": [
            "Мебели",
            "Градински инструменти",
            "Декорация",
            "Уреди за домакинството",
            "Отопление и охлаждане",
            "Дом и градина"
        ]
    },
    {
        "name": "Здраве и красота",
        "subcategories": [
            "Грижа за кожата",
            "Козметика",
            "Хранителни добавки",
            "Фитнес оборудване",
            "Лична хигиена",
            "Здраве и красота"
        ]
    },
    {
        "name": "Осветление",
        "subcategories": [
            "Вътрешно осветление",
            "Външно осветление",
            "LED осветление",
            "Лампи и крушки",
            "Осветителни тела",
            "Осветление"
        ]
    },
    {
        "name": "Техника и електроника",
        "subcategories": [
            "Компютри и лаптопи",
            "Смартфони и таблети",
            "Телевизори и аудио",
            "Домакински уреди",
            "Гейминг",
            "Техника и електроника"
        ]
    },
    {
        "name": "Детски игри",
        "subcategories": [
            "Образователни игри",
            "Играчки за навън",
            "Настолни игри",
            "Пъзели и конструктори",
            "Видео игри",
            "Детски игри"
        ]
    },
    {
        name: "Admin",
        subcategories: [
            "Без категория",
            "Неналични"
        ]
    }
    // Add more categories here if needed
];

export default categories;